/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SelectMultiIconSvg from './select-multi-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SelectMultiIconSvg {...validProps} />;
}
SvgComponent.iconName = 'selectMultiIcon';

export const SelectMultiIcon = svgIconWrapper(SvgComponent);
